import {useParams, useRouteMatch} from 'react-router-dom';
import {useOffice} from '../../../../../../../contexts/office/context';
import {UserPlaylistItems} from '../../../../../../../components/user-playlists/user-playlist-items';
import {useAuth} from '../../../../../../../contexts/auth/context';
import {RolePermissionType} from '../../../../../../../backend/enums/role-permission-type';
import {CaregiverMode, ScreenPaths} from '../../../../../../../enums';
import {translations} from '../../../../../../../i18n/translations';
import {useTranslation} from 'react-i18next';
import {PlaylistsRepository} from '../../../../../../../repositories/playlists';
import {useEffect, useState} from 'react';
import {Playlist} from '../../../../../../../backend/interfaces/playlist';

export default function SeniorPlaylistItemsProfessionalCaregiverOfficeScreen() {
  const officeContext = useOffice();
  const {t} = useTranslation();
  const {url} = useRouteMatch();
  const [playlist, setPlaylist] = useState<Playlist | undefined>();
  let {id, entityId, playlistId}: {id: string; entityId: string; playlistId: string} = useParams();
  const userName = (officeContext.state.userForm?.user.displayName ||
    officeContext.state.userForm?.user.name)!;
  const {hasWritePermission} = useAuth();
  const canWritePlaylists = hasWritePermission(
    RolePermissionType.Seniors_DigitalInclusion_Playlists
  );

  useEffect(() => {
    const getPlaylist = async () => {
      try {
        // Get the playlist
        const result =
          await PlaylistsRepository.instance.getPlaylistByIdForEntityAsAffiliatedForEntity(
            entityId,
            playlistId,
            true
          );

        if (result) {
          // Set playlist
          setPlaylist(result);
        } else {
          // Error
          throw new Error('Empty playlist.');
        }
      } catch (error) {
        // Log
        console.debug('🔴 Could not get the playlist.', error);
      }
    };

    // Get the playlist
    getPlaylist();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playlistId]);

  return (
    <UserPlaylistItems
      caregiverMode={CaregiverMode.SystemAdministrator}
      canWrite={canWritePlaylists}
      userId={id}
      entityId={entityId}
      userName={userName}
      playlistId={playlistId}
      playlistItemRowBaseLinkUrl={`${url}/items`}
      isLoadingHeader={!playlist}
      headerTitleCrumbs={[
        {
          label: t(translations.screen_paths.professional_caregiver_seniors),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}`,
        },
        {
          label: userName || '',
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_PersonalData}${ScreenPaths.Senior_Profile}`,
        },
        {
          label: t(translations.role_permissions_section['digital-inclusion']),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_DigitalInclusion}`,
        },
        {
          label: t(translations.screen_paths.senior_playlists),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_DigitalInclusion}${ScreenPaths.Senior_Playlists}`,
        },
        {
          label: playlist?.name || '',
          link: url,
        },
      ]}
    />
  );
}
